import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

// Ленивая подгрузка страниц — код модуля не попадает в стартовый бандл.
const ShipmentsLayout = lazy(() => import('./ShipmentsLayout'));
const ShipmentsList = lazy(() => import('./pages/ShipmentsList'));
const ShipmentsCheckout = lazy(() => import('./pages/ShipmentsCheckout'));
const ShipmentDetail = lazy(() => import('./pages/ShipmentDetail'));
const PackageDetail = lazy(() => import('./pages/PackageDetail'));
const AllShipments = lazy(() => import('./pages/AllShipments'));
const ShipmentsSettings = lazy(() => import('./pages/ShipmentsSettings'));
const ShipmentsStatusSettings = lazy(() => import('./pages/ShipmentsStatusSettings'));
const ShipmentsStatusTransitionSettings = lazy(() => import('./pages/ShipmentsStatusTransitionSettings'));

const ShipmentsRouters = (
  <Route
    path="/shipments"
    element={
      <ProtectedRoute minRole="USER" appSlug="shipments">
        <ShipmentsLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<ShipmentsList />} />
    <Route path="checkout" element={<ShipmentsCheckout />} />
    <Route path="packages/:id" element={<PackageDetail />} />
    <Route path="report" element={<AllShipments />} />
    <Route path="settings/permissions" element={<ShipmentsSettings />} />
    <Route path="settings/statuses" element={<ShipmentsStatusSettings />} />
    <Route path="settings/status-transitions" element={<ShipmentsStatusTransitionSettings />} />
    <Route path=":id" element={<ShipmentDetail />} />
  </Route>
);

export default ShipmentsRouters;
